define('views/abstract-comments/edit-form',[
  "globals",
  "backbone",
  "./create-form"
], function (globals, Backbone, CommentForm) {
  "use strict";

  return CommentForm.extend({
    EDIT_EVENT_NAME: "edit:comment",

    render: function () {
      CommentForm.prototype.render.call(this);
      this.$("[type = submit]").text(Messages("comment.form.save_changes"));
      this.updateFieldsFromModel();
      return this;
    },

    submit: function (e) {
      e.preventDefault();

      this.model.save(this.serialize(), {
        merge: true,
        success: _.bind(function () {
          this.collection.trigger(this.EDIT_EVENT_NAME, this.model);
        }, this)
      });

      this.reset();
    },

    serialize: function () {
      return this.$el.serializeArray().reduce(function (json, field) {
        json[field.name] = field.value;
        return json;
      }, {});
    },

    updateFieldsFromModel: function () {
      _.each(this.model.fields, function (name) {
        this.$("[name = " + name + "]").val(this.model.get(name));
        this.$("[id = highlight]").hide();
        if(this.model.attributes.attachment){
          var attachmentText = this.model.attributes.attachment.substring(this.model.attributes.attachment.indexOf("_") + 1)
          this.$("[id = attachment-indicator]").show();
          this.$("[id = attachment-name]").text(attachmentText);
        }
        if(this.model.attributes.highlight) {
          this.$("[id = highlight]").val(this.model.attributes.highlight);
          this.$("[id = highlight-indicator]").show();
          this.$("[id = highlight-text]").text(JSON.parse(this.model.attributes.highlight).uiData);
        }
      }, this);

      return this;
    }
  });
});


